import React, { useEffect, useState } from 'react';
import { resumeAPI } from '../services/api';

export default function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    resumeAPI.stats().then(({ data }) => { setStats(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="page-container"><div className="loading-spinner"><div className="spinner" /></div></div>;
  if (!stats) return <div className="page-container"><div className="empty-state"><p>Failed to load dashboard.</p></div></div>;

  const Section = ({ title, data, labelKey, countKey }) => (
    <div className="card" style={{ marginBottom: 0 }}>
      <div className="card-body">
        <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-heading)', marginBottom: 20 }}>{title}</h3>
        {(data || []).slice(0, 12).map((item, i) => {
          const label = typeof labelKey === 'function' ? labelKey(item) : item[labelKey];
          return (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 0', borderBottom: i < data.length - 1 ? '1px solid var(--border)' : 'none' }}>
              <span style={{ fontSize: '.88rem', color: 'var(--text-primary)' }}>{(label || '').toString().trim() || '(blank)'}</span>
              <span style={{ fontFamily: 'var(--font-mono)', fontSize: '.82rem', color: 'var(--accent)', fontWeight: 500 }}>{item[countKey]}</span>
            </div>
          );
        })}
        {(!data || data.length === 0) && <p style={{ color: 'var(--text-muted)', fontSize: '.88rem' }}>No data available</p>}
      </div>
    </div>
  );

  return (
    <div className="page-container">
      <div className="page-header">
        <div><h1 className="page-title">Dashboard</h1><p className="page-subtitle">Overview of your resume database</p></div>
      </div>

      <div className="stat-grid">
        <div className="stat-card"><div className="stat-label">Total Resumes</div><div className="stat-value accent">{stats.total_resumes?.toLocaleString()}</div></div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: 24 }}>
        <Section title="Visa Status Breakdown" data={stats.visa_statuses} labelKey="visastatus" countKey="count" />
        <Section title="Top Locations" data={stats.top_locations} labelKey={item => (item.trimmed_city || item.city || '').trim()} countKey="count" />
        <Section title="Top Employers" data={stats.top_employers} labelKey="employer" countKey="count" />
        <Section title="Relocation Preference" data={stats.relocation_stats} labelKey="relocation" countKey="count" />
      </div>
    </div>
  );
}
